import {useModel} from "hooks"
import styles from "./ProjectedEndDateCard.module.css"
import {ReactComponent as GradIcon} from "./grad.svg"
import moment from "moment"
import {getFieldLabel, isFieldActive} from "helpers/common"
import {Settings} from "types/settings"
import {useTranslation} from "react-i18next"

type Props = {
    projectedEndDate?: string
    contractEndDate?: string
    naccasGradDate?: string
}

export function ProjectedEndDateCard(props: Props) {
    const {projectedEndDate, contractEndDate, naccasGradDate} = props
    const model = useModel()
    const userDateFormat = model.getUserDateFormat()
    const showProjectedEndDate = isFieldActive(model, Settings.GeneralLabel.ProjectedEndDate)
    const showNaccasGradDate = model.clientSetting.isNaccasGraduationDateEnabled
    const {t} = useTranslation(["common", "user"])

    return (
        <div className={styles.container}>
            <GradIcon className={styles.cardIcon} />
            {showProjectedEndDate && (
                <div className={styles.subContainer}>
                    <span className={styles.title}>
                        {getFieldLabel(
                            model,
                            Settings.GeneralLabel.ProjectedEndDate,
                            t("studentInfo.projectedEndDate")
                        )}
                    </span>
                    <span className={styles.value}>
                        {projectedEndDate ? moment(projectedEndDate).format(userDateFormat) : "--"}
                    </span>
                </div>
            )}
            {showNaccasGradDate && (
                <div className={styles.subContainer}>
                    <span className={styles.title}>{t("studentInfo.naccasGradDate")}</span>
                    <span className={styles.value}>
                        {naccasGradDate ? moment(naccasGradDate).format(userDateFormat) : "--"}
                    </span>
                </div>
            )}
            {projectedEndDate && (
                <div className={styles.subContainer}>
                    <span className={styles.distant}>{moment(projectedEndDate).diff(moment(), "days")} days</span>
                    <span className={styles.description}>till graduation</span>
                </div>
            )}
            <div className={styles.subContainer}>
                <span className={styles.contractTitle}>Contract grad date</span>
                <span className={styles.value}>
                    {contractEndDate ? moment(contractEndDate).format(userDateFormat) : "--"}
                </span>
            </div>
        </div>
    )
}
